/*
Controller: Applications

Operations:
  getApplications
  createApplication
  getApplicationByUserId
  getApplicationById
  updateUserApplication
*/
var Api = require('../config')
var UsersApplicationDef = require('../definitions/UsersApplication')

var Applications = (function () {
  /*
  Operation: getApplications
  Get a list of applications
  Parameters:
    sortBy: field to sort by, possible values: &#39;applicationStatus&#39; , &#39;updatedAt&#39; , &#39;foundryName&#39; , &#39;userName&#39;
    sortDirection: direction to sort by, asc or desc
    filter: filter by status, possible values: &#39;all&#39;, &#39;in_review&#39;, &#39;approved&#39;, &#39;rejected&#39;, &#39;exists&#39;
    search: search over multiple fields - userName, foundryName, email
    page: page number, starting with 1
    perPage: number of items per page, max 50
  Responses:
    HTTP 200: Collection of ApplicationSummary objects, last submitted first
  */
  function getApplicationsApplications (sortBy, sortDirection, filter, search, page, perPage) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      parameters['filter'] = filter
      parameters['search'] = search
      parameters['page'] = page
      parameters['perPage'] = perPage
      var path = '/applications'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createApplication
  Create Application
  Parameters:
    bodyRequest: Application object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Application creation failed
    HTTP 403: Operation not permitted
  */
  function createApplicationApplications (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        UsersApplicationDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/applications'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getApplicationByUserId
  Get User Application based on User Id
  Parameters:
    userId: User id
  Responses:
    HTTP 200: Valid response
    HTTP 403: Operation not permitted
    HTTP 404: User application not found
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getApplicationByUserIdApplications (userId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/applications/user/{userId}'
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getApplicationById
  Get User Application based on Application Id
  Parameters:
    userApplicationId: User Application id
  Responses:
    HTTP 200: Valid response
    HTTP 403: Operation not permitted
    HTTP 404: User application not found
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getApplicationByIdApplications (userApplicationId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userApplicationId) {
          throw new Error('userApplicationId: Missing parameter')
        }
        if (userApplicationId && !(typeof userApplicationId === 'string')) {
          throw new Error('userApplicationId: Wrong type: Got "' + (typeof userApplicationId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/applications/{userApplicationId}'
      path = path.replace('{' + 'userApplicationId' + '}', userApplicationId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateUserApplication
  Update User Application
  Parameters:
    userApplicationId: User Application id
    bodyRequest: Application object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Application creation failed
    HTTP 403: Operation not permitted
  */
  function updateUserApplicationApplications (userApplicationId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userApplicationId) {
          throw new Error('userApplicationId: Missing parameter')
        }
        if (userApplicationId && !(typeof userApplicationId === 'string')) {
          throw new Error('userApplicationId: Wrong type: Got "' + (typeof userApplicationId) + '", but expected: "string"')
        }
        UsersApplicationDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/applications/{userApplicationId}'
      path = path.replace('{' + 'userApplicationId' + '}', userApplicationId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getApplications'] = getApplicationsApplications
  ret['createApplication'] = createApplicationApplications
  ret['getApplicationByUserId'] = getApplicationByUserIdApplications
  ret['getApplicationById'] = getApplicationByIdApplications
  ret['updateUserApplication'] = updateUserApplicationApplications
  return ret
})()

module.exports = Applications
